export const validFiltersProfit = (param) => {
  if (typeof param === 'number') {
    const str = param.toString();
    if (/e/i.test(str)) return false;
    return /^-?(0|([1-9]\d*))(\.\d+)?$/.test(str);
  } if (typeof param === 'string') {
    return /^-?(0|([1-9]\d*))(\.\d+)?$/.test(param);
  }
  return false;
};
